<script setup lang="ts">
import type { TextColors } from "../colors/colors";
import type { CommandItemBaseProps } from "./types";
import { computed } from "vue";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps & {
  color: [string, typeof TextColors[keyof typeof TextColors] | ""];
}>();

const name = computed(() => props.color[0]);
const hexColor = computed(() => props.color[1]);

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setColor(hexColor.value)
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    @click="run"
    @keydown.enter="run"
  >
    <template #icon>
      <span
        :style="{ color: hexColor }"
        class="flex size-4 flex-row items-center justify-center rounded-sm border border-slate-200"
        aria-hidden="true"
      >
        A
      </span>
    </template>
    <span>
      <span class="capitalize">{{ name }}</span>
    </span>
  </SuggestionListItem>
</template>
